import { Select } from "antd";
import { useCustomDomainSelectOptions } from "components/UI/Selects/CustomDomainSelectSearchable/useCustomDomainSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useMemo } from "react";

const DEFAULT_DOMAIN_VALUE = "default";

interface CustomDomainSelectSearchableProps extends SearchableSelectWrapperProps {
    includeDefault?: boolean;
}

export const CustomDomainSelectSearchable = ({
    includeDefault = true,
    ...props
}: CustomDomainSelectSearchableProps) => {
    const { t } = usePaldockTranslation("forms.general-fields.domain");
    const hookResult = useCustomDomainSelectOptions();

    const enhancedHookResult = useMemo(() => {
        if (!includeDefault) {
            return hookResult;
        }

        const defaultOption = { label: t("default_option"), value: DEFAULT_DOMAIN_VALUE };
        return {
            ...hookResult,
            options: [defaultOption, ...hookResult.options],
        };
    }, [hookResult, includeDefault, t]);

    if (enhancedHookResult.loading && !enhancedHookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={enhancedHookResult}
            translationNamespace="forms.general-fields.domain"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};

export { DEFAULT_DOMAIN_VALUE };
